import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Box, Text, Anchor } from 'grommet';
import { FormNextLink } from 'grommet-icons';
import { useAppTheme } from '@Components/Context';
import { Seo } from '@Components/Control';
import { AdminNavWrapper } from '@Components/Navigation';
import { fileImportsConfig, paths } from '@Components/configs';
import { SectionContainer } from '../../Account/AccountPage';

const AdminSearchesPage = ({
  small,
  location,
}) => {
  const searchesImports = fileImportsConfig.filter((importConfig) => importConfig.category === 'searches') || null;
  const { theme: { page }, isDarkMode } = useAppTheme();
  const usePageBg = isDarkMode ? page.background : page.altBg;
  const useSectionBg = isDarkMode ? page.altBg : page.background;

  return (
    <AdminNavWrapper
      small={small}
      location={location}
      bannerProps={{
        title: 'View and manage company searches',
        subTitle: 'Searches',
      }}
    >
      <Seo />
      <Box flex width="100%" background={usePageBg} pad="2rem" gap="2rem">
        <SectionContainer
          small={small}
          sectionTitle="Searches File Imports"
          sectionBg={useSectionBg}
          textColor={page.primaryText}
          customGap="1rem"
        >
          <Box direction="column" gap="0.5rem">
            <Anchor href={paths.adminCreateSearchesImport}>
              <Box direction="row" align="center" gap="0.5rem" width="100%">
                <FormNextLink color={page.altHighlight} size="1rem" />
                <Text size="1rem" color={page.altHighlight} textAlign="center">
                  Create Bulk Searches
                </Text>
              </Box>
            </Anchor>
            {searchesImports?.map((config) => (
              <Anchor href={config.path} key={config.key}>
                <Box direction="row" align="center" gap="0.5rem" width="100%">
                  <FormNextLink color={page.altHighlight} size="1rem" />
                  <Text size="1rem" color={page.altHighlight} textAlign="center">
                    {config.label}
                  </Text>
                </Box>
              </Anchor>
            ))}
          </Box>
        </SectionContainer>
      </Box>
    </AdminNavWrapper>
  );
};

AdminSearchesPage.propTypes = {
  small: PropTypes.bool.isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
    search: PropTypes.string.isRequired,
    key: PropTypes.string.isRequired,
  }).isRequired,
};

export default connect(null, null)(AdminSearchesPage);
